// Shared theme tokens + utilities for the "7 ليالي بيننا" funnel.
// Premium dark warm aesthetic — deep brown/black/burgundy + cream + soft gold.

export const SEVEN_THEME = {
  bg: "#0A0606",
  bgRaised: "#150C0C",
  bgCard: "#1C1010",
  burgundy: "#2A1414",
  burgundyDeep: "#1A0808",
  text: "#F5EAD3",
  textMuted: "#CFC3A1",
  textDim: "#A7956E",
  textFaint: "#7A6F50",
  gold: "#C9A66A",
  goldBright: "#E2C281",
  goldDeep: "#8A6E3D",
  goldLine: "rgba(201,166,106,0.30)",
  cream: "#F5EAD3",
};

export const FONT_AR = "'Tajawal','IBM Plex Sans Arabic',-apple-system,system-ui,sans-serif";
export const FONT_DISPLAY = "'Tajawal','IBM Plex Sans Arabic',serif";

export const ensureFonts = () => {
  if (typeof document === "undefined") return;
  if (document.getElementById("seven-font")) return;
  const l = document.createElement("link");
  l.id = "seven-font";
  l.rel = "stylesheet";
  l.href = "https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800;900&display=swap";
  document.head.appendChild(l);
};

// localStorage helpers — used by AccessGuard and progress tracker.
export const STORE_KEY = "seven_nights_v1";

export const getStored = () => {
  try { return JSON.parse(localStorage.getItem(STORE_KEY) || "{}"); }
  catch { return {}; }
};

export const setStored = (patch) => {
  try {
    const cur = getStored();
    localStorage.setItem(STORE_KEY, JSON.stringify({ ...cur, ...patch }));
  } catch { /* private mode — silently ignore */ }
};

export const visitorId = () => {
  try {
    let v = localStorage.getItem("seven_vid");
    if (!v) {
      v = window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : `${Math.random().toString(36).slice(2)}${Date.now()}`;
      localStorage.setItem("seven_vid", v);
    }
    return v;
  } catch { return "anon"; }
};
